import GrayButton from "../../components/GrayButton";
import {useAppContext} from "../../context/AppContext";

export default function SelectionInfo({type, ...props}) {
    const {selection} = useAppContext()

    const getSurvey = () => {
        if(selection[type].survey?.title) {
            return `(${selection[type].survey?.title})`;
        }

        return ''
    }

    return (
        <GrayButton
            {...props}
            style={{
                fontSize: '14pt',
                width: '100%',
                marginBottom: 16,
                height: 40,
            }}
        >
            <b style={{marginRight: 4}}>
                {selection[type].project?.information?.title?.trim()}:
            </b>{' '}
            {selection[type].plan?.type}{' '}
            {selection[type].river && `, ${selection[type].river?.river} - ${selection[type].river?.reach}`}
            {'  '}{getSurvey()}
        </GrayButton>
    )
}